import { j as m } from "./jsx-runtime-3tyXYecC.mjs";
import d, { useState as Pe, useRef as ne, useEffect as me, useCallback as $e, forwardRef as Ce, isValidElement as Me } from "react";
import { f as G } from "./index-LyFokDcn.mjs";
import { m as V } from "./tss-DN0acMKN.mjs";
import { M as Te, d as Le } from "./constants-CnFYFetN.mjs";
import { M as Oe, T as je } from "./menu-item-D2hpbuev.mjs";
import { D as De } from "./divider-Dq5lrAFK.mjs";
function Ae(r, t) {
  let e = new Array(r).fill(!0).map((n, a) => a);
  if (typeof t == "function") {
    const n = e.map((o) => [o, t(o)]), a = n.filter((o) => typeof o[1] == "string"), s = n.filter((o) => typeof o[1] > "u"), i = a.reduce((o, u) => {
      const c = u[0], p = u[1], R = o.get(p) || [];
      return o.set(p, [...R, c]), o;
    }, /* @__PURE__ */ new Map());
    e = [], i.forEach((o) => {
      e = [...e, ...o];
    }), e = [...e, ...s.map((o) => o[0])];
  }
  return e;
}
function re(r, t) {
  return (e) => r(t[e]);
}
const Fe = (r) => {
  const { getDisabled: t, getGroup: e, onSelect: n, renderItem: a, total: s, ...i } = r;
  if (typeof e != "function")
    return r;
  const o = Ae(s, e);
  return {
    getDisabled: typeof t == "function" ? re(t, o) : void 0,
    getGroup: re(e, o),
    onSelect: typeof n == "function" ? re(n, o) : void 0,
    renderItem: (u, c) => {
      const p = o[u];
      return a(p, c);
    },
    total: s,
    ...i
  };
}, Ne = (r) => (t) => {
  const e = Fe(t);
  return /* @__PURE__ */ m.jsx(r, { ...e });
};
function _e(r, t, e) {
  const n = Pe(e);
  return typeof r < "u" && typeof t == "function" ? [r, t] : n;
}
const xe = (r, t) => {
  const e = ne();
  e.current = t, me(() => {
    const n = (a) => {
      typeof e.current == "function" && e.current(a);
    };
    return r.addEventListener("keydown", n), () => {
      r.removeEventListener("keydown", n);
    };
  }, [e, r]);
};
class We {
  constructor({ getDisabled: t, getTotal: e, initialPath: n }) {
    if (this._path = [], this.getDisabled = t || (() => !1), this.getTotal = e, this.getDisabled(n))
      throw new Error("You cannot pass in an initial path that is disabled.");
    this._path = n || [0];
  }
  get leafIndex() {
    return this.path.slice(-1)[0] || 0;
  }
  get path() {
    return this._path;
  }
  get parentPath() {
    return this.path.slice(0, -1);
  }
  next() {
    const t = this.getTotal(this.parentPath);
    if (this.leafIndex === t - 1)
      return this.first(), this;
    for (let e = this.leafIndex + 1; e < t; e++) {
      const n = [...this.parentPath, e];
      if (!this.getDisabled(n)) {
        this._path = n;
        break;
      }
      if (e === t - 1)
        return this.first();
    }
    return this;
  }
  prev() {
    if (this.leafIndex === 0)
      return this.last(), this;
    for (let t = this.leafIndex - 1; t > -1; t--) {
      const e = [...this.parentPath, t];
      if (!this.getDisabled(e)) {
        this._path = e;
        break;
      }
      if (t === 0)
        return this.last();
    }
    return this;
  }
  dive() {
    const t = this.getTotal(this.path);
    for (let e = 0; e < t; e++) {
      const n = [...this.path, e];
      if (!this.getDisabled(n)) {
        this._path = n;
        break;
      }
    }
    return this;
  }
  surface() {
    return this._path = this.parentPath.length ? this.parentPath : this.path, this;
  }
  first() {
    const t = this.getTotal(this.parentPath);
    for (let e = 0; e < t; e++) {
      const n = [...this.parentPath, e];
      if (!this.getDisabled(n)) {
        this._path = n;
        break;
      }
    }
    return this;
  }
  last() {
    const t = this.getTotal(this.parentPath);
    for (let e = t - 1; e > -1; e--) {
      const n = [...this.parentPath, e];
      if (!this.getDisabled(n)) {
        this._path = n;
        break;
      }
    }
    return this;
  }
}
function He(r, t) {
  switch (t) {
    case "ArrowDown":
      r.next();
      break;
    case "ArrowUp":
      r.prev();
      break;
    case "ArrowRight":
      r.dive();
      break;
    case "ArrowLeft":
      r.surface();
      break;
    case "End":
    case "PageDown":
      r.last();
      break;
    case "Home":
    case "PageUp":
      r.first();
      break;
  }
}
function Ke({ activePath: r, getDisabled: t, getTotal: e, key: n }) {
  const a = new We({
    getTotal: e,
    getDisabled: t,
    initialPath: r || []
  });
  return He(a, n), a.path;
}
const Be = ({
  activePath: r = [],
  getDisabled: t,
  getTotal: e,
  onChange: n,
  targetElement: a = document
}) => {
  const s = {
    activePath: r,
    getDisabled: t,
    getTotal: e,
    targetElement: a
  }, i = ne(s);
  i.current = s, xe(a, (o) => {
    const u = i.current, c = Ke({ ...u, key: o.key });
    u.activePath !== c && n(c);
  });
}, Ve = ({
  activeIndex: r,
  getDisabled: t,
  keyboardTarget: e,
  onChange: n,
  total: a
}) => {
  Be({
    activePath: typeof r > "u" ? void 0 : [r],
    getDisabled: typeof t == "function" ? (s) => t(s[0]) : void 0,
    getTotal: (s) => s.length === 0 ? a : 0,
    onChange: (s) => {
      n(s[0]);
    },
    targetElement: e
  });
}, Ue = ({ activeIndex: r, onSelect: t, keyboardTarget: e = document }) => {
  xe(e, (n) => {
    const a = e instanceof HTMLInputElement && (e.type === "text" || e.type === "search");
    typeof r == "number" && typeof t == "function" && (n.key === "Enter" || n.key === " " && !a) && t(r);
  });
}, qe = (r, t) => {
  me(() => {
    typeof t < "u" && r(t);
  }, [t, r]);
};
function T() {
  return T = Object.assign || function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, T.apply(this, arguments);
}
function Ye(r, t) {
  if (r == null) return {};
  var e = {}, n = Object.keys(r), a, s;
  for (s = 0; s < n.length; s++)
    a = n[s], !(t.indexOf(a) >= 0) && (e[a] = r[a]);
  return e;
}
var Je = ["bottom", "height", "left", "right", "top", "width"], Qe = function(t, e) {
  return t === void 0 && (t = {}), e === void 0 && (e = {}), Je.some(function(n) {
    return t[n] !== e[n];
  });
}, C = /* @__PURE__ */ new Map(), Se, Xe = function r() {
  var t = [];
  C.forEach(function(e, n) {
    var a = n.getBoundingClientRect();
    Qe(a, e.rect) && (e.rect = a, t.push(e));
  }), t.forEach(function(e) {
    e.callbacks.forEach(function(n) {
      return n(e.rect);
    });
  }), Se = window.requestAnimationFrame(r);
};
function Ze(r, t) {
  return {
    observe: function() {
      var n = C.size === 0;
      C.has(r) ? C.get(r).callbacks.push(t) : C.set(r, {
        rect: void 0,
        hasRectChanged: !1,
        callbacks: [t]
      }), n && Xe();
    },
    unobserve: function() {
      var n = C.get(r);
      if (n) {
        var a = n.callbacks.indexOf(t);
        a >= 0 && n.callbacks.splice(a, 1), n.callbacks.length || C.delete(r), C.size || cancelAnimationFrame(Se);
      }
    }
  };
}
var B = typeof window < "u" ? d.useLayoutEffect : d.useEffect;
function et(r, t) {
  t === void 0 && (t = {
    width: 0,
    height: 0
  });
  var e = d.useState(r.current), n = e[0], a = e[1], s = d.useReducer(tt, t), i = s[0], o = s[1], u = d.useRef(!1);
  return B(function() {
    r.current !== n && a(r.current);
  }), B(function() {
    if (n && !u.current) {
      u.current = !0;
      var c = n.getBoundingClientRect();
      o({
        rect: c
      });
    }
  }, [n]), d.useEffect(function() {
    if (n) {
      var c = Ze(n, function(p) {
        o({
          rect: p
        });
      });
      return c.observe(), function() {
        c.unobserve();
      };
    }
  }, [n]), i;
}
function tt(r, t) {
  var e = t.rect;
  return r.height !== e.height || r.width !== e.width ? e : r;
}
var rt = function() {
  return 50;
}, nt = function(t) {
  return t;
}, at = function(t, e) {
  var n = e ? "offsetWidth" : "offsetHeight";
  return t[n];
}, st = function(t) {
  for (var e = Math.max(t.start - t.overscan, 0), n = Math.min(t.end + t.overscan, t.size - 1), a = [], s = e; s <= n; s++)
    a.push(s);
  return a;
};
function ot(r) {
  var t, e = r.size, n = e === void 0 ? 0 : e, a = r.estimateSize, s = a === void 0 ? rt : a, i = r.overscan, o = i === void 0 ? 1 : i, u = r.paddingStart, c = u === void 0 ? 0 : u, p = r.paddingEnd, R = p === void 0 ? 0 : p, g = r.parentRef, P = r.horizontal, x = r.scrollToFn, E = r.useObserver, j = r.initialRect, S = r.onScrollElement, N = r.scrollOffsetFn, w = r.keyExtractor, U = w === void 0 ? nt : w, q = r.measureSize, D = q === void 0 ? at : q, L = r.rangeExtractor, ae = L === void 0 ? st : L, be = P ? "width" : "height", _ = P ? "scrollLeft" : "scrollTop", I = d.useRef({
    scrollOffset: 0,
    measurements: []
  }), se = d.useState(0), ye = se[0], oe = se[1];
  I.current.scrollOffset = ye;
  var ze = E || et, Re = ze(g, j), Ee = Re[be];
  I.current.outerSize = Ee;
  var A = d.useCallback(function(l) {
    g.current && (g.current[_] = l);
  }, [g, _]), ie = x || A;
  x = d.useCallback(function(l) {
    ie(l, A);
  }, [A, ie]);
  var ue = d.useState({}), ce = ue[0], Y = ue[1], we = d.useCallback(function() {
    return Y({});
  }, []), W = d.useRef([]), O = d.useMemo(function() {
    var l = W.current.length > 0 ? Math.min.apply(Math, W.current) : 0;
    W.current = [];
    for (var v = I.current.measurements.slice(0, l), f = l; f < n; f++) {
      var b = U(f), h = ce[b], k = v[f - 1] ? v[f - 1].end : c, y = typeof h == "number" ? h : s(f), z = k + y;
      v[f] = {
        index: f,
        start: k,
        size: y,
        end: z,
        key: b
      };
    }
    return v;
  }, [s, ce, c, n, U]), le = (((t = O[n - 1]) == null ? void 0 : t.end) || c) + R;
  I.current.measurements = O, I.current.totalSize = le;
  var F = S ? S.current : g.current, J = d.useRef(N);
  J.current = N, B(function() {
    if (!F) {
      oe(0);
      return;
    }
    var l = function(f) {
      var b = J.current ? J.current(f) : F[_];
      oe(b);
    };
    return l(), F.addEventListener("scroll", l, {
      capture: !1,
      passive: !0
    }), function() {
      F.removeEventListener("scroll", l);
    };
  }, [F, _]);
  var fe = ut(I.current), de = fe.start, pe = fe.end, Q = d.useMemo(function() {
    return ae({
      start: de,
      end: pe,
      overscan: o,
      size: O.length
    });
  }, [de, pe, o, O.length, ae]), he = d.useRef(D);
  he.current = D;
  var Ie = d.useMemo(function() {
    for (var l = [], v = function(k, y) {
      var z = Q[k], H = O[z], M = T(T({}, H), {}, {
        measureRef: function(K) {
          if (K) {
            var ee = he.current(K, P);
            if (ee !== M.size) {
              var ge = I.current.scrollOffset;
              M.start < ge && A(ge + (ee - M.size)), W.current.push(z), Y(function(Ge) {
                var te;
                return T(T({}, Ge), {}, (te = {}, te[M.key] = ee, te));
              });
            }
          }
        }
      });
      l.push(M);
    }, f = 0, b = Q.length; f < b; f++)
      v(f);
    return l;
  }, [Q, A, P, O]), ve = d.useRef(!1);
  B(function() {
    ve.current && Y({}), ve.current = !0;
  }, [s]);
  var X = d.useCallback(function(l, v) {
    var f = v === void 0 ? {} : v, b = f.align, h = b === void 0 ? "start" : b, k = I.current, y = k.scrollOffset, z = k.outerSize;
    h === "auto" && (l <= y ? h = "start" : l >= y + z ? h = "end" : h = "start"), h === "start" ? x(l) : h === "end" ? x(l - z) : h === "center" && x(l - z / 2);
  }, [x]), Z = d.useCallback(function(l, v) {
    var f = v === void 0 ? {} : v, b = f.align, h = b === void 0 ? "auto" : b, k = Ye(f, ["align"]), y = I.current, z = y.measurements, H = y.scrollOffset, M = y.outerSize, $ = z[Math.max(0, Math.min(l, n - 1))];
    if ($) {
      if (h === "auto")
        if ($.end >= H + M)
          h = "end";
        else if ($.start <= H)
          h = "start";
        else
          return;
      var K = h === "center" ? $.start + $.size / 2 : h === "end" ? $.end : $.start;
      X(K, T({
        align: h
      }, k));
    }
  }, [X, n]), ke = d.useCallback(function() {
    for (var l = arguments.length, v = new Array(l), f = 0; f < l; f++)
      v[f] = arguments[f];
    Z.apply(void 0, v), requestAnimationFrame(function() {
      Z.apply(void 0, v);
    });
  }, [Z]);
  return {
    virtualItems: Ie,
    totalSize: le,
    scrollToOffset: X,
    scrollToIndex: ke,
    measure: we
  };
}
var it = function(t, e, n, a) {
  for (; t <= e; ) {
    var s = (t + e) / 2 | 0, i = n(s);
    if (i < a)
      t = s + 1;
    else if (i > a)
      e = s - 1;
    else
      return s;
  }
  return t > 0 ? t - 1 : 0;
};
function ut(r) {
  for (var t = r.measurements, e = r.outerSize, n = r.scrollOffset, a = t.length - 1, s = function(c) {
    return t[c].start;
  }, i = it(0, a, s, n), o = i; o < a && t[o].end < n + e; )
    o++;
  return {
    start: i,
    end: o
  };
}
const ct = ({ activeIndex: r, total: t }) => {
  const e = ne(null), n = ot({
    estimateSize: $e(() => 32, []),
    parentRef: e,
    size: t
  });
  return qe(n.scrollToIndex, r), {
    overallHeight: n.totalSize,
    scrollContainerRef: e,
    virtualItems: n.virtualItems
  };
}, lt = V()(({ palette: r, spacing: t, mode: e }) => ({
  root: {
    display: "flex",
    flexGrow: 1,
    flexShrink: 1,
    outline: e === Te.Dye ? `1px solid ${Le.main}` : void 0,
    overflowY: "auto",
    padding: G.ifFeature("encore", `${t(2)} 0`)
  },
  groupEndWithGutter: {
    paddingBottom: t(1)
  },
  groupEndWithoutGutter: {},
  groupLabelWithGutter: {
    display: "none"
  },
  groupLabelWithoutGutter: {},
  gutter: {
    backgroundColor: r.gray[100],
    position: "relative",
    width: 140
  },
  virtualItem: {
    left: 0,
    position: "absolute",
    right: 0
  },
  virtualItems: {
    flexGrow: 1,
    position: "relative"
  }
})), ft = V()(({ palette: r, typography: t }) => {
  var e, n, a, s;
  return {
    root: {
      boxSizing: "border-box",
      color: r.gray[800],
      fontSize: (e = t.medium) == null ? void 0 : e.fontSize,
      fontWeight: t.fontWeightSemibold,
      left: 0,
      lineHeight: (n = t.medium) == null ? void 0 : n.lineHeight,
      overflow: "hidden",
      paddingLeft: 12,
      paddingRight: 12,
      paddingTop: 13,
      position: "absolute",
      textAlign: "right",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "100%"
    },
    smallSize: {
      fontSize: (a = t.small) == null ? void 0 : a.fontSize,
      lineHeight: (s = t.small) == null ? void 0 : s.lineHeight
    }
  };
}), dt = (r) => {
  const { classes: t, cx: e } = ft(), { className: n, end: a, name: s, renderGroup: i, size: o = "medium", start: u } = r;
  return /* @__PURE__ */ m.jsx(
    "div",
    {
      className: e(
        t.root,
        {
          [t.smallSize]: o === "small" || o === "teenie"
        },
        n
      ),
      style: {
        top: `${u}px`,
        height: `${a - u}px`
      },
      children: typeof i == "function" ? i(s) : s
    },
    s
  );
}, pt = V()(({ palette: r }) => ({
  root: {},
  gutterGroupSeparator: {
    borderTop: `1px solid ${r.gray[300]}`
  }
})), ht = (r, t) => {
  const e = r.reduce((n, a) => {
    const s = t(a.index);
    if (typeof s == "string") {
      const i = n[s] || [];
      s && (n[s] = [...i, a]);
    }
    return n;
  }, {});
  return Object.keys(e).map((n) => {
    const a = [...e[n]].sort((s, i) => s.start - i.start);
    return {
      end: a[a.length - 1].end,
      name: n,
      start: Math.max(a[0].start, 0)
    };
  });
}, vt = (r) => {
  const { classes: t } = pt(), { getGroup: e, renderGroup: n, size: a, virtualItems: s } = r, i = ht(s, e);
  return /* @__PURE__ */ m.jsx("div", { className: t.root, children: i.map((o, u) => /* @__PURE__ */ m.jsx(
    dt,
    {
      className: u !== 0 ? t.gutterGroupSeparator : "",
      renderGroup: n,
      size: a,
      ...o
    },
    o.name
  )) });
}, gt = V()(({ palette: r, spacing: t, typography: e }) => {
  var n, a;
  return {
    root: {},
    groupLabel: {
      color: r.gray[700],
      fontSize: (n = e.teenie) == null ? void 0 : n.fontSize,
      lineHeight: (a = e.teenie) == null ? void 0 : a.lineHeight,
      // @startCleanup encore
      marginLeft: G.ifFeature("encore", void 0, 10),
      // @endCleanup encore
      margin: G.ifFeature("encore", t(1, 2))
    },
    groupEnd: {
      paddingBottom: G.ifFeature("encore", 0, 5)
    },
    groupSeparator: {
      // @startCleanup encore
      borderTop: G.ifFeature("encore", void 0, `1px solid ${r.gray[300]}`),
      // @endCleanup encore
      padding: G.ifFeature("encore", `4px ${t(1)}`)
    },
    groupStart: {
      paddingTop: G.ifFeature("encore", 0, t(1))
    }
  };
}), mt = ({
  getGroup: r,
  index: t,
  total: e
}) => {
  const n = t + 1;
  return typeof r == "function" && n < e ? r(n) : void 0;
}, xt = ({ getGroup: r, index: t }) => {
  const e = t - 1;
  return typeof r == "function" && e >= 0 ? r(e) : void 0;
}, St = {
  getDisabled: () => !1
}, bt = Ce((r, t) => {
  const { classes: e, cx: n } = gt(), { active: a, className: s, getDisabled: i, getGroup: o, index: u, onActive: c, onSelect: p, renderGroup: R, renderItem: g, size: P, style: x, total: E } = {
    ...St,
    ...r
  }, j = i(u), S = typeof o == "function" ? o(u) : void 0, N = mt({ getGroup: o, index: u, total: E }), w = xt({ getGroup: o, index: u }), D = { active: a, disabled: j, onClick: () => {
    !j && typeof p == "function" && p(u);
  }, onMouseEnter: () => {
    !j && typeof c == "function" && c(u);
  }, size: P }, L = g(u, D);
  return /* @__PURE__ */ m.jsxs(
    "li",
    {
      className: n(
        e.root,
        {
          [e.groupEnd]: !!S && S !== N,
          [e.groupSeparator]: G.ifFeature(
            "encore",
            !1,
            !!S && !!w && S !== w
          ),
          [e.groupStart]: !!S && S !== w
        },
        s
      ),
      ref: t,
      style: x,
      children: [
        !!S && !!w && S !== w && G.ifFeature(
          "encore",
          /* @__PURE__ */ m.jsx("div", { className: e.groupSeparator, children: /* @__PURE__ */ m.jsx(De, { color: "neutral-extra-weak" }) })
        ),
        S && S !== w ? /* @__PURE__ */ m.jsx("div", { className: e.groupLabel, children: typeof R == "function" ? R(S) : null }) : null,
        Me(L) ? L : /* @__PURE__ */ m.jsx(Oe, { ...D, children: /* @__PURE__ */ m.jsx(je, { children: L }) })
      ]
    }
  );
}), yt = (r) => {
  const {
    activeIndex: t,
    className: e,
    getDisabled: n = () => !1,
    getGroup: a,
    hasGutter: s,
    onActive: i,
    onSelect: o,
    renderGroup: u,
    renderItem: c,
    size: p,
    total: R
  } = r, { classes: g, cx: P } = lt(), x = ct({
    activeIndex: t,
    total: R
  });
  return /* @__PURE__ */ m.jsxs("div", { className: P(g.root, e), ref: x.scrollContainerRef, children: [
    s ? /* @__PURE__ */ m.jsx("div", { className: g.gutter, style: { height: `${x.overallHeight}px` }, children: typeof a == "function" ? /* @__PURE__ */ m.jsx(
      vt,
      {
        getGroup: a,
        renderGroup: u,
        size: p,
        virtualItems: x.virtualItems
      }
    ) : null }) : null,
    /* @__PURE__ */ m.jsx("ul", { className: g.virtualItems, style: { height: `${x.overallHeight}px` }, children: x.virtualItems.map((E) => /* @__PURE__ */ m.jsx(
      bt,
      {
        active: t === E.index,
        classes: {
          root: g.virtualItem,
          groupEnd: s ? g.groupEndWithGutter : g.groupEndWithoutGutter,
          groupLabel: s ? g.groupLabelWithGutter : g.groupLabelWithoutGutter
        },
        getDisabled: n,
        getGroup: a,
        index: E.index,
        onActive: i,
        onSelect: o,
        ref: E.measureRef,
        renderGroup: u,
        renderItem: c,
        size: p,
        style: { top: `${E.start}px` },
        total: R
      },
      E.key
    )) })
  ] });
}, zt = Ne((r) => {
  const {
    activeIndex: t,
    defaultActiveIndex: e,
    getDisabled: n,
    keyboardTarget: a,
    onActive: s,
    onSelect: i,
    total: o,
    ...u
  } = r, [c, p] = _e(t, s, e);
  return Ve({
    activeIndex: c,
    getDisabled: n,
    keyboardTarget: a,
    onChange: p,
    total: o
  }), Ue({
    activeIndex: c,
    keyboardTarget: a,
    onSelect: i
  }), /* @__PURE__ */ m.jsx(
    yt,
    {
      activeIndex: c,
      getDisabled: n,
      onActive: p,
      onSelect: i,
      total: o,
      ...u
    }
  );
});
zt.defaultProps = {
  getDisabled: () => !1
};
export {
  zt as M
};
//# sourceMappingURL=menu-list-30mL0jmk.mjs.map
